// SP //
'use strict';
var spreload = false;

function isFunction(functionToCheck) {
	var getType = {};
	return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

function setInvalid(message, messageField, field) {
	messageField.removeClass('valid').addClass('invalid').html(message);
	if (field)
		field.get(0).setCustomValidity(message);
}

function setValid(message, messageField, field) {
	messageField.removeClass('invalid').addClass('valid').html(message);
	if (field)
		field.get(0).setCustomValidity('');
}

function setLoading(message, messageField, field) {
	messageField.removeClass('invalid').removeClass('valid').html(message);
	if (field)
		field.get(0).setCustomValidity('');
}

function magnify(obj) {
	var i_path = $(obj).data('img');
	if (i_path) {
		$('body').append('<div id="overlay"></div><div id="magnify"><img src="' + i_path + '"></div>');
		$('#overlay').fadeIn('fast').click(function(event) {
			event.preventDefault();
			$('#overlay, #magnify').fadeOut('fast', function() {
				$('#magnify, #overlay').remove();
			});
		});
		$('#magnify img').load(function() {
			$('#magnify').css({
					left: ($(document).width() - $('#magnify').outerWidth()) / 2,
					top: ($(window).height() - $('#magnify').outerHeight()) / 2
				})
				.fadeIn('fast').click(function(event) {
					event.preventDefault();
					$('#overlay, #magnify').fadeOut('fast', function() {
						$('#magnify, #overlay').remove();
					});
				});
		});
	}
}

var sp = {};
function getE(name)
{
	var elem;
	if (document.getElementById)
		elem = document.getElementById(name);
	else if (document.all)
		elem = document.all[name];
	else if (document.layers)
		elem = document.layers[name];
	return elem;
}
function autocomplete(inp, arr) {
	var currentFocus;
	inp.addEventListener("input", function(e) {
		var a, b, i, val = this.value;
		closeAllLists();
		if (!val) { return false;}
		currentFocus = -1;
		a = document.createElement("DIV");
		a.setAttribute("id", this.id + "autocomplete-list");
		a.setAttribute("class", "autocomplete-items");
		this.parentNode.appendChild(a);
		for (i = 0; i < arr.length; i++) {
			var ind = arr[i].text.toUpperCase().indexOf(val.toUpperCase());
			if (ind>-1) {
				b = document.createElement("DIV");
				b.innerHTML = arr[i].text.substr(0, ind);
				b.innerHTML += "<strong>" + arr[i].text.substr(ind, val.length) + "</strong>";
				b.innerHTML += arr[i].text.substr(val.length+ind);
				b.innerHTML += "<input type='hidden' value='" + arr[i].val + "'>";
				b.addEventListener("click", function(e) {
					inp.value = this.getElementsByTagName("input")[0].value;
					var event = new Event('change');
					inp.dispatchEvent(event);
					closeAllLists();
				});
				a.appendChild(b);
			}
		}
	});
	inp.addEventListener("keydown", function(e) {
		var x = document.getElementById(this.id + "autocomplete-list");
		if (x) x = x.getElementsByTagName("div");
		if (e.keyCode == 40) {
			currentFocus++;
			addActive(x);
		} else if (e.keyCode == 38) { //up
			currentFocus--;
			addActive(x);
		} else if (e.keyCode == 13) {
			e.preventDefault();
			if (currentFocus > -1) {
				if (x) x[currentFocus].click();
			}
		}
	});
	function addActive(x) {
		if (!x) return false;
		removeActive(x);
		if (currentFocus >= x.length) currentFocus = 0;
		if (currentFocus < 0) currentFocus = (x.length - 1);
		x[currentFocus].classList.add("autocomplete-active");
	}
	function removeActive(x) {
		for (var i = 0; i < x.length; i++) {
			x[i].classList.remove("autocomplete-active");
		}
	}
	function closeAllLists(elmnt) {
		var x = document.getElementsByClassName("autocomplete-items");
		for (var i = 0; i < x.length; i++) {
			if (elmnt != x[i] && elmnt != inp) {
				x[i].parentNode.removeChild(x[i]);
			}
		}
	}
	document.addEventListener("click", function (e) {
		closeAllLists(e.target);
	});
}
function spmodal_set(response) {
	if (response.REFRESH_DATA) {
		phpbbAlertTimer = setTimeout(function() {
			window.location = response.REFRESH_DATA.url;

			// Hide the alert even if we refresh the page, in case the user
			// presses the back button.
			$dark.fadeOut(phpbb.alertTime, function() {
				if (typeof alert !== 'undefined') {
					alert.hide();
				}
			});
		}, response.REFRESH_DATA.time * 1000); // Server specifies time in seconds
	}else{
		$('#modal_box').remove();
		$(response).appendTo('body').spmodal().on($.spmodal.BEFORE_CLOSE, function(event, modal) {
			$('#modal_box').remove();
		});
		$('.isjs').show();
		$('.isjs_hide').hide();
		modal_sp(true);
	}
}
function clearForm(oForm) {
	var elements = oForm.elements;
	oForm.reset();
	for(var i=0; i<elements.length; i++) {
		var field_type = elements[i].type.toLowerCase();
		switch(field_type) {
			case "text":
			case "password":
			case "textarea":
			case "hidden":
				elements[i].value = "";
				break;
			case "radio":
			case "checkbox":
				if (elements[i].checked) {
					elements[i].checked = false;
				}
				break;
			case "select-one":
			case "select-multi":
				elements[i].selectedIndex = 0;
				break;
			default:
				break;
		}
	}
}
function apply_js(obj)
{
	var obj = $(obj);
	$('.isjs', obj).show();
	$('.isjs_hide', obj).hide();
	$('.noajax', obj).remove();
	$('.seljs', obj).css('cursor', 'pointer');
}

sp.cart = function(){
	$('.chHS')
		.on('click', 'span', function(){
			var div = $(this).closest('div'),
			div2 = $(div).closest('div.panel');
			$('span', div).toggle();
			$('.formorder', div2).toggle();
		});
	$(".datebox").pickmeup({
		position		: 'right',
		hide_on_select	: true,
		locale			: lang_ru,
		max				: 'D'
	});
	$('#orderlist')
		.on('change', '.formorder .ch_comm', function(){
			var $obj = $(this),
			$form = $obj.closest('form'),
			name = $obj.attr('name'),
			val = $obj.val();
			$('textarea[name="'+name+'"]', $form).val(val);
			$('input[name=submit_comm]', $form).trigger('click');
		})
		.on('click', '.formorder .order_del', function(){
			var $form = $(this).closest('form'),
			ck = $(this).closest('.sp_check');
			$('input[type=checkbox]', ck).prop("checked", true);
			$('input[name=submit_del]', $form).trigger('click');
		})
		.on('click', '.order-kol .btn', function(){
			var $form = $(this).closest('form'),
			div = $(this).closest('div'),
			input = $('input', div),
			name = input.attr('name'),
			quantity = $(this).data('quantity'),
			max = parseInt($(this).data('max')),
			val = parseInt(input.val()) + parseInt(quantity);
			if (val < 1) val=1;
			if (!isNaN(max) && val>max) val = max;
			$('input[name="'+name+'"]', $form).val(val);
			$('input[name=submit_save]', $form).trigger('click');
			return false;
		})
		.on('change', '.order-kol input', function(){
			var $form = $(this).closest('form'),
			input = $(this),
			name = input.attr('name'),
			max = parseInt($(this).data('max')),
			val = parseInt(input.val());
			if (val < 1) val=1;
			if (!isNaN(max) && val>max) val = max;
			$('input[name="'+name+'"]', $form).val(val);
			$('input[name=submit_save]', $form).trigger('click');
			return false;
		});

	phpbb.addAjaxCallback('klubsp.payment', function(response) {
		var panel = $(this).closest('.payment_panel');
		panel.html($(response).find('.payment_panel'));
		$(".datebox", panel).pickmeup({
			position		: 'right',
			hide_on_select	: true,
			locale			: lang_ru,
			max				: 'D'
		});
		update_ajax(panel);
	});

	phpbb.addAjaxCallback('klubsp.formorder', function(response) {
		var id = $(this).closest('form').attr('id'),
			$obj = $(response.TEXT).find('#'+id+'_'),
			html = $obj.html() || '',
			cont = $('#'+id+'_');
		cont.html(html);
		$('.isjs', cont).show();
		$('.isjs_hide', cont).hide();
		update_ajax(cont);
	});

	$('.chHS span').toggle();
	$('.formorder').toggle();
};
sp.catalog = function(){
	sp.upd_cost = false;
	sp.upd_prop = false;
	sp.upd_prop2 = false;
	$(document).on('click touchstart',function(e) {
		if ($('.mob-filter__btn').hasClass('active')) {
			if ((!$(e.target).is(".mob-filter__btn"))&&(!$(e.target).is("#catalog_filter"))&&(!$(e.target).is("#catalog_filter *"))) {
				$('.mob-filter__btn').removeClass('active')
				$('#catalog_filter').removeClass('active')
				$('.shadow_full').removeClass('active');
				$('body').removeClass('lock');
			};
		}
	});
	$('.mob-filter__btn').click(function(event) {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active')
			$('#catalog_filter').removeClass('active')
			$('.shadow_full').removeClass('active');
			$('body').removeClass('lock');
		}else{
			$(this).addClass('active')
			$('#catalog_filter').addClass('active')
			$('.shadow_full').addClass('active');
			$('body').addClass('lock');
		}
	});
	quantity__btn('#lots_body');
	sp.range('#filter_cost_block');
	if (sp.page_ajax)
	{
		sp.resultSuccess = function(response){
			phpbb.clearLoadingTimeout();
			$('#user_id_old').val($(response).find('#user_id_old').val());
			$('#pc_sel_old').val($(response).find('#pc_sel_old').val());
			$('.action-bar .pagination-sp').html($(response).find('.action-bar .pagination-sp').html());
			sp.handleDrops($('.action-bar .pagination-sp'));
			if (sp.upd_cost){
				$('#filter_cost_block').html($(response).find('#filter_cost_block').html());
				sp.range('#filter_cost_block');
			}
			if (sp.upd_prop){
				$('#prop-block').html($(response).find('#prop-block').html());
			}
			else if (sp.upd_prop2){
				$('.prop__block').each(function(){
					var $this = $(this),
						id = $this.data('id');
					if (id != sp.upd_prop2){
						$this.html($(response).find('.prop__block[data-id='+id+']').html());
					}
				})
			}
			$('#lots_body').html($(response).find('#lots_body').html());
			$('#more_page').html($(response).find('#more_page').html());
			var title = $(response).filter('title').text();
			phpbb.history.pushUrl(sp.ajax_url, title, {
				url: sp.ajax_url,
				title: title
			});
			document.title = title;
			update_ajax($('#lots_body'));
			sp.softScroll($('#catalog_action'));
			apply_js('#lots_body');
			quantity__btn('#lots_body');
		};
		sp.resultSuccessMore = function(response){
			phpbb.clearLoadingTimeout();
			$('#user_id_old').val($(response).find('#user_id_old').val());
			$('#pc_sel_old').val($(response).find('#pc_sel_old').val());
			$('.action-bar .pagination-sp').html($(response).find('.action-bar .pagination-sp').html());
			sp.handleDrops($('.action-bar .pagination-sp'));
			$('#lots_body').append($(response).find('#lots_body').html());
			$('#more_page').html($(response).find('#more_page').html());
			update_ajax($('#lots_body'));
			apply_js('#lots_body');
			quantity__btn('#lots_body');
		};
		sp.bindPagination();
		$('#filter-box-form').submit(function (event) {
			event.preventDefault();
			var form = $(this),
				url = form.attr('action'),
				data = form.serialize();
			url = url+'?'+data;
			sp.loadPage(url);
			return false;
		});
		$('#form-sort')
			.submit(function (event) {
				event.preventDefault();
				var form = $(this),
					url = form.attr('action'),
					data = form.serialize(),
					url2 = url+(url.split('?')[1] ? '&':'?')+data;
				sp.loadPage(url2);
				sp.ajax_url = url;
				return false;
			});
		$('.catalog_url').click(function(event){
			event.preventDefault();
			var cat_list = $(this).closest('.cat_list');
			$('.catalog_url.active', cat_list).removeClass('active');
			$(this).addClass('active');
			sp.upd_cost = true;
			sp.upd_prop = true;
			sp.upd_prop2 = false;
			$('#filter-box-form input[name=keywords]').val('');
			var url = $(this).attr('href');
			$('#filter-box-form').attr('href', url);
			sp.loadPage(url);
		})
		$('#filter-box-form')
			.on('change', '.filter-list', function(){
				sp.upd_cost = true;
				sp.upd_prop = true;
				sp.upd_prop2 = false;
				$(this).closest('form').submit();
			})
			.on('click', '.search-btn', function(event){
				event.preventDefault();
				sp.upd_cost = true;
				sp.upd_prop = true;
				sp.upd_prop2 = false;
				$(this).closest('form').submit();
			})
			.on('change', '.filter_cost input', function(){
				sp.upd_cost = false;
				sp.upd_prop = true;
				sp.upd_prop2 = false;
				$(this).closest('form').submit();
			})
			.on('mouseup', '.range-input', function(){
				sp.upd_cost = false;
				sp.upd_prop = true;
				sp.upd_prop2 = false;
				$(this).closest('form').submit();
			})
			.on('touchend', '.range-input', function(){
				sp.upd_cost = false;
				sp.upd_prop = true;
				sp.upd_prop2 = false;
				$(this).closest('form').submit();
			})
			.on('change', '.prop-checkbox input', function(){
				sp.upd_cost = $(this).hasClass('ch_cost');
				sp.upd_prop = false;
				sp.upd_prop2 = $(this).closest('.prop__block').data('id');
				$(this).closest('form').submit();
			})
			.on('click', 'button[type=reset]', function(event){
				event.preventDefault();
				var form = $(this).closest('form');
				$('input[name=keywords]', form).val('');
				var cost_min = $('input[name=cost_min]', form),
					cost_max = $('input[name=cost_max]', form);
				cost_min.val(cost_min.attr('min'));
				cost_max.val(cost_max.attr('max'));
				$('#prop-block input[type=checkbox]', form).prop('checked', false);
				sp.upd_cost = true;
				sp.upd_prop = true;
				sp.upd_prop2 = false;
				form.submit();
			})
		$('#lots_body')
			.on('click', '.lots_body-filter_reset', function(event){
				event.preventDefault();
				var form = $(this).closest('form');
				$('.prop_sel-checkbox input', form).each(function(){
					var $this = $(this);
					$this.prop('checked', false);
					$('#'+$this.data('id')).prop('checked', false);
				})
				var url = form.attr('action'),
					data = form.serialize();

				url = url+'?'+data;
				sp.loadPage(url);
				return false;
			})
			.on('change', '#lots_body-filter .prop_sel-checkbox input', function(event){
				var $this = $(this),
					form = $this.closest('form'),
					url = form.attr('action'),
					data = form.serialize();
				$('#'+$this.data('id')).prop('checked', false);
				url = url+'?'+data;
				sp.loadPage(url);
			})
	}
	$('#form-sort')
		.on('change', 'select', function(){
			$(this).closest('form').submit();
		});
	$('body')
		.on('keyup', '#filter-box-form .prop_filter', function () {
			var filter = $(this).val().toString().toUpperCase(),
				div = $(this).closest('div'),
				ul = $('.prop-box', div),
				obj, txtValue;
			$('.prop_row', ul).each(function(index, el){
				obj = $(el);
				txtValue = obj.data('prop').toString();
				if (txtValue.toUpperCase().indexOf(filter) > -1) {
					obj.show();
				} else {
					obj.hide();
				}
			})
		})
		.on('change', '#lots_body .prop_select', function(e){
			var block = $(this).closest('.lot_card');
			var cost = parseFloat($('.lot_price', block).data('cost'));
			$('.prop_select:checked', block).each(function(){
				cost += parseFloat($(this).data('cost'));
			});
			$('.lot_price span',block).html(cost.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 "));

		});
};
sp.catalog_edit = function(){
	var isUpload = false;
	if (window.File && window.FileList && window.FileReader) {
		isUpload = true;
	}
	if (isUpload){
		$('.drag').addClass('upload');
	}
	$('.catalog_upd').change(function(){$(this).closest('form').submit();});
	var updateSliderCounter = function(obj, slick, currentIndex) {
		var currentSlide = slick.slickCurrentSlide() + 1;
		var slidesCount = slick.slideCount;
		$('.countsSlides .current', obj).html(currentSlide);
		$('.countsSlides .ful_cnt', obj).html(slidesCount);
		//$(sliderCounter).text(currentSlide + '/' +slidesCount)
	};
	$("#lots_body_edit .sp_slider").on('init', function(event, slick) {
		$(this).append('<div class="countsSlides"><span class="current">0</span> / <span class="ful_cnt">0</span></div>');
		updateSliderCounter($(this), slick);
	}).on('reInit afterChange', function(event, slick, currentSlide, nextSlide) {
		updateSliderCounter($(this), slick, currentSlide);
	});
	$("#lots_body_edit .sp_slider").slick({
		dots: false,
		arrows: true,
		slidesToScroll: 1,
	})
	$("#lots_body_edit")
		.on('change', ".lot_change", function(){$(this).closest('form').submit();})
		.on('click', ".image_add", function(e){
			e.preventDefault();
			var $this = $(this),
				lot_box = $this.closest('.lot_box'),
				form = $this.closest('form'),
				statustxt = $('.statustxt', form),
				lot_id = lot_box.data('id'),
				fileinfo = $('.fileinfo', form);
			fileinfo.html('');

			$this.closest('form').ajaxSubmit({
				dataType: 'json',
				uploadProgress: function(event, position, total, percentComplete) { //on progress
					statustxt.html(percentComplete + '%'); //update status text
				},
				clearForm: true,
				complete: function (c, d) {
					if (c.responseJSON.error)
					$('.sp_error', lot_box).html(c.responseJSON.error).show();
					if (c.responseJSON.img){
						for(var i in c.responseJSON.img){
							$(".sp_slider", lot_box).slick('slickAdd', '<div class="sp_slider__item" data-imgid="' + c.responseJSON.img[i].imgid + '"><div class="lot_thumb"><img src="' + c.responseJSON.img[i].src + '" /></div><input type="text" value="' + c.responseJSON.img[i].order + '" data-imgid="' + c.responseJSON.img[i].imgid + '" class="inputbox ch_pic_order"></div>');
						}
					}
				}
			});
		})
		.on('click', ".image_del", function(e){
			e.preventDefault();
			var $this = $(this),
				lot_box = $this.closest('.lot_box'),
				lot_id = lot_box.data('id'),
				currentSlide = $(".sp_slider", lot_box).slick('slickCurrentSlide'),
				current_item = $(".slick-current", lot_box),
				pic_id = current_item.data('imgid');
			$.ajax({
				url: $this.attr('href'),
				type: 'POST',
				data: {
					pic_id: pic_id
				},
				dataType: 'json',
				complete: function(result, errors) {
					$(".sp_slider", lot_box).slick('slickRemove', currentSlide);
				}
			});
			return false;
		})
		.on('change', '.ch_pic_order', function(e){
			e.preventDefault();
			var $this = $(this),
				lot_box = $this.closest('.lot_box'),
				lot_id = lot_box.data('id'),
				pic_id = $this.data('imgid'),
				order = $this.val();
			$.ajax({
				type: 'POST',
				data: {
					task: 'ch_pic_order',
					lot_id: lot_id,
					pic_id: pic_id,
					order: order
				},
				dataType: 'json'
			});
			return false;
		})
		.on('click', ".reloadryd", function(){
			var obj = $(this),
				fieldset = obj.closest("fieldset"),
				opt_idx = obj.data('id'),
				val = $("input[name='lot_prop[" + opt_idx + "]']", fieldset).val().replace(/\[.*\]/, '');
			$("input[name='lot_bundle["+opt_idx+"]']", fieldset).val(val);
			obj.closest('form').submit();
		})
		.on('change', ".img_fp", function(event){
			var $form = $(this).closest('form');
			$('.sp_error', $form).hide();
			var fileinfo = $('.fileinfo', $form);
			fileinfo.html('');
			if (isUpload){
				var files = event.originalEvent.target.files || event.originalEvent.dataTransfer.files;
				if (files.length){
					SPFileUpload(files, fileinfo);
				}
			}
		})
		.on('dragenter', ".drag", function(event) {
			event.stopPropagation();
			event.preventDefault();
			$(this).addClass('drop_here');
			return false;
		})
		.on('dragleave', ".drag", function(event) {
			event.stopPropagation();
			event.preventDefault();
			$(this).removeClass('drop_here');
			return false;
		})
		.on('dragover', ".drag", function(event) {
			event.stopPropagation();
			event.preventDefault();
			return false;
		})
		.on('drop', ".drag", function(event) {
			event.stopPropagation();
			event.preventDefault();
			var $this = $(this),
				lot_box = $this.closest('.lot_box'),
				form = $this.closest('form'),
				statustxt = $('.statustxt', form),
				lot_id = lot_box.data('id'),
				fileinfo = $('.fileinfo', form);

			$('.sp_error', form).hide();
			$(this).removeClass('drop_here');
			var srcRegex = /src=\"([^\s]+)\"/ig;
			fileinfo.html('');
			if (isUpload){
				var $input = $('.img_fp', form),
					files = event.originalEvent.target.files || event.originalEvent.dataTransfer.files;
				if (files.length){
					SPFileUpload(files, fileinfo);
					var ajaxData = new FormData(form.get(0));
					$.each( files, function(i, file) {
						ajaxData.append( $input.attr('name'), file );
					});
					ajaxData.append('ajax', 1);
					$.ajax({
						url: form.attr('action'),
						type: form.attr('method'),
						data: ajaxData,
						dataType: 'json',
						cache: false,
						contentType: false,
						processData: false,
						uploadProgress: function(event, position, total, percentComplete) { //on progress
							statustxt.html(percentComplete + '%'); //update status text
						},
						complete: function (c, d) {
							if (c.responseJSON.error)
							$('.sp_error', lot_box).html(c.responseJSON.error).show();
							if (c.responseJSON.img){
								for(var i in c.responseJSON.img){
									$(".sp_slider", lot_box).slick('slickAdd', '<div class="sp_slider__item" data-imgid="' + c.responseJSON.img[i].imgid + '"><div class="lot_thumb"><img src="' + c.responseJSON.img[i].src + '" /></div><input type="text" value="' + c.responseJSON.img[i].order + '" data-imgid="' + c.responseJSON.img[i].imgid + '" class="inputbox ch_pic_order"></div>');
								}
							}
						}
					});
					return false;
				}
			}
			var data = event.originalEvent.dataTransfer.getData('text/html'),
				img_data = srcRegex.exec(data);
			if (img_data != null){
				$("#img_fp_" + lot_id + "_url").val(img_data[1]);
			}
			return false;
		});
	update_ajax('#lots_body');
	function SPFileUpload(files, fileinfo){
		var html = '';
		for (var i = 0, f; (f = files[i]); i++) {
			if (!f.type.match('image.*')) continue;
			html += "File information: <strong>" + f.name +
			"</strong> type: <strong>" + f.type +
			"</strong> size: <strong>" + f.size +
			"</strong> bytes<br/>";
		}
		fileinfo.html(html);
	}
	if ($('*').is($("#properties"))){
		var countries = [];
		$('#properties_sel option').each(function() {
			var html = $(this).html();
			countries.push({text:html, val:html});
		});
		$('#properties_sel').hide();
		autocomplete(getE("properties"), countries);
	}
	if ($('*').is($(".properties_sel"))){
		var countries = [];
		$('#properties_sel option').each(function() {
			var html = $(this).html();
			countries.push({text:html, val:html});
		});
		$('.properties_sel').hide();
		$('.properties').each(function() {
			autocomplete(getE($(this).prop('id')), countries);
		});
	}
	phpbb.addAjaxCallback('klubsp.lot_del', function(response) {
		var $obj = $(response).find("#lots_body_edit");
		$('#lots_body_edit').html($obj.html());
		if (isUpload){
			$('.drag').addClass('upload');
		}
		$("#lots_body_edit .sp_slider").slick({
			dots: true,
			slidesToScroll: 1
		});
		update_ajax('#lots_body_edit');
	});
	phpbb.addAjaxCallback('klubsp.lot_save', function(response) {
		$('.status', this).css('color', response.color).html(response.msg);
		$('.a_lot_url', this).attr('href', $('input[name=lot_url]', this).val());
	});
	phpbb.addAjaxCallback('klubsp.lot_prop_add', function(response) {
		if (response){
			var $this = $(this),
			lot_box = $this.closest('.lot_box');
			$('.prop_box', lot_box).append('<dl class="details"><dt>'+response.name+':</dt><dd><input class="inputbox lot_change" name="lot_prop['+response.attr_id+']" type="text" value=""></dd></dl>');
		}
	});
	phpbb.addAjaxCallback('klubsp.lot_prop_edit', function(response) {
		if (response){
			let lot_box = $('.lot_box[data-id='+response.lot_id+']'),
				input = $('input[name="lot_prop['+response.attr_id+']"]', lot_box);
			input.val(response.value).trigger('change');
		}
		$.spmodal.close();
	});
	phpbb.addAjaxCallback('klubsp.cat_search', function(response) {
		var $obj = $(response).find("#result_cat_search");
		$('#result_cat_search').html($obj.html());
	});
};
function lot_save_f(){
	$('.status', this).html('');
	return true;
}
sp.comment = function(){
	$('#orderlist')
		.on('change', '.formorder .ch_comm', function(){
			var $obj = $(this),
			$form = $obj.closest('form').trigger('submit');
		});
};
sp.exchange = function (){
	$('#exchangelist')
	.on('click', '.order_del', function(){
		var $form = $(this).closest('form'),
		ck = $(this).closest('.sp_check');
		$('input[type=checkbox]', ck).prop("checked", true);
		$form.trigger('submit');
	});
};
phpbb.addAjaxCallback('klubsp.exchangelist', function(response) {
	var form = $(this);
	form.html($(response).find('form').html());
	$('.isjs', form).show();
	$('.isjs_hide', form).hide();
});
phpbb.addAjaxCallback('klubsp.exchangelist_org', function(response) {
	var form = $(this),
		user_id = form.data('user');
	$('#modal_box .close-spmodal').trigger('click');
	if (response.status=='ok'){
		$('textarea[name="comment[' + response.order_id + ']"').html(response.msg);
		$('input[name="cost[' + response.order_id + ']"').val(response.cost);
		$('#userdata' + user_id).trigger('submit');
		spreload = true;
	}
});
sp.lot = function(fajax){
	$('.isjs').show();
	$('.isjs_hide').hide();
	if( getE('sp_slider_big') ){
		$('#sp_slider_big').slick({
			// infinite: false,
			dots: false,
			accessibility:false,
			slidesToShow:1,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			asNavFor:'#sp_slider_small',
			fade: true,
			responsive: [{
				breakpoint: 992,
				settings: {
					draggable: true,
					dots: true,
				}
			},{
				breakpoint: 768,
				settings: {
					dots: true,
				}
			}]
		});
	}
	if( getE('sp_slider_small') ){
		$('#sp_slider_small').slick({
			infinite: false,
			dots: false,
			accessibility:false,
			slidesToShow:4,
			autoplaySpeed: 5000,
			focusOnSelect:true,
			asNavFor:'#sp_slider_big',
			responsive: [{
				breakpoint: 1248,
				settings: {
					slidesToShow:3,
				}
			},{
				breakpoint: 768,
				settings: {
					settings: "unslick"
				}
			}]
		});
	}
	quantity__btn('#lot_body');
	$('#feedback_add').click(function(e){
		e.preventDefault();
		var $this = $(this),
			form = $this.closest('form');

		form.ajaxSubmit({
			dataType: 'json',
			clearForm: true,
			complete: function (c, d) {
				if (c.responseJSON.feedback){
					$('#lot_feedback').html(c.responseJSON.feedback);
					update_ajax('#lot_feedback');
				}
			}
		});
		return false;
	});
	$('.prop_img').click(function(e){
		var index = $(this).data('img-index');
		$('#sp_slider_big').slick('slickGoTo', index -1);
	});
	$('.prop_img, .prop_color').click(function(e){
		var val = $(this).attr('title'),
			div = $(this).closest('.prop');
		$('.prop_title_value', div).html(val);
	});
	$('.prop_select').change(function(e){
		transform_cost();
	});
	$('.comb_check').click(function(e){
		let id = $(this).val();
		for(let i in comb_list[id]){
			$('input.prop_select[value="'+i+'"]').attr('disabled', comb_list[id][i]);
		}
	})
	if (fajax){
		update_ajax('#lot_body');
	}
	transform_cost();
};
function transform_cost()
{
	var cost = parseFloat($('#lot_price').data('cost'));
	$('#lot_body .prop_select:checked').each(function(){
		cost += parseFloat($(this).data('cost'));
	});
	$('#lot_price').html(cost.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 "));

	var cost = parseFloat($('#lot_price_f').data('cost'));
	$('#lot_body .prop_select:checked').each(function(){
		cost += parseFloat($(this).data('cost_f'));
	});
	$('#lot_price_f').html(cost.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 "));
}
function quantity__btn(block){
	$(block + ' .quantity__btn').click(function(event) {
		var input = $(this).parent().find('.quantity__input'),
			n = parseInt(input.val());
		if($(this).hasClass('dwn')){
			n=n-1;
			if (n<2){$(this).addClass('disable')}
			if(n<1){n=1;}
		}else{
			n=n+1;
			$(this).parent().children('.dwn').removeClass('disable')
		}
		input.val(n);
		return false;
	});
}
sp.office = function(){
	$(".status_data").pickmeup({
		position		: 'right',
		hide_on_select	: true,
		locale			: lang_ru,
		max				: 'D'
	});
	$('#findorders').change(function(){
		var code = $(this).val();
		$('.orders[data-code="'+code+'"]').prop("checked", true);
		$(this).val('');
	});
	$('.o_ch_sel').change(function(){
		sel4office($(this));
	});
	autocomplete4office();
	$('#purch_list .ajaxmodal').click(function(event) {
		event.preventDefault();
		$.ajax({
			url : this.href,
			type : 'POST',
			dataType: 'html',
			success : function(result) {
				$(result).appendTo('body').spmodal();
			}
		});
	});
	$(".not_enter input[type=text]")
		.keydown(function(event){
			if(event.keyCode == 13){
				event.preventDefault();
				$(this).trigger('change');
				$(this).val('');
				return false;
			}
		})
		.keyup(function(){
			if(this.value.length == 13){
				$(this).trigger('change');
				$(this).val('');
			}
		})
	;
	$('#barcode').keyup(function(){
		if(this.value.length == 13){
			$(this).closest('form').trigger('submit');
			$(this).val('');
		}
	});
	phpbb.addAjaxCallback('klubsp.officepage', update_office_page);
	phpbb.addAjaxCallback('klubsp.office_auto', function(data){
		$('#purch_list').prepend(data.list_auto+'<hr/>');
	});
};
function autocomplete4office(){
	if ($('*').is($("#u"))){
		var countries = [];
		$('#u_sel option').each(function() {
			countries.push({text: $(this).html(), val: $(this).data('name')});
		});
		autocomplete(getE("u"), countries);
	}
}
function sel4office($this){
	var $form = $this.closest('form'),
		o = $('input[name="o"]', $form).val(),
		o2 = $('input[name="o2"]', $form).val(),
		n = $this.attr('name'),
		u = $this.val(),
		state ={},
		url = $form.attr('action') + '?o=' + o;
	state.o = o;
	if (o2 != undefined)
	{
		url += '&o2=' + o2;
		state.o2 = o2;
	}
	url += '&' + n + '=' + u;
	state[n] = u;
	if (window.history.pushState) {
		window.history.pushState(state, document.title, url);
	}
	$('#u').val('');
	$('#uid').val('');
	$('#u_sel').val(0);
	$.ajax({
		url: $form.attr('action'),
		type: $form.attr('method'),
		data: state,
		dataType: 'json',
		cache: false,
		success: function(data){
			update_office_page(data);
		}
	});
}
function update_office_page(data){
	$('#purch_list').html(data.list);
	if (data.user_list){
		$('#u_sel').html(data.user_list);
	}
	autocomplete4office();
	$('#purch_list .ajaxmodal').click(function(event) {
		event.preventDefault();
		$.ajax({
			url : this.href,
			type : 'POST',
			dataType: 'html',
			success : function(result) {
				$(result).appendTo('body').spmodal();
			}
		});
	});
	update_ajax('#purch_list');
}
sp.orderlist = function(){
	if (sp.page_ajax)
	{
		sp.resultSuccess = function(response){
			phpbb.clearLoadingTimeout();
			var $response = $(response);
			$('#order_block').html($response.find('#order_block').html());
			$('.action-bar .pagination-sp').html($response.find('.action-bar .pagination-sp').html());
			sp.handleDrops($('.action-bar .pagination-sp'));
			$('#more_page').html($response.find('#more_page').html());
			update_ajax($('#lots_body'));
			sp.softScroll($('#order_block'));
		};
		sp.resultSuccessMore = function(response){
			phpbb.clearLoadingTimeout();
			var $response = $(response);
			$('#order_block').append($response.find('#order_block').html());
			$('.action-bar .pagination-sp').html($response.find('.action-bar .pagination-sp').html());
			sp.handleDrops($('.action-bar .pagination-sp'));
			$('#more_page').html($response.find('#more_page').html());
			update_ajax($('#lots_body'));
		};
		sp.bindPagination();
	}
};
/**
 * Adds Ajax functionality for the pagination.
 */
sp.bindPagination = function() {
	$('.action-bar .pagination-sp')
		.on('click', 'a:not(.dropdown-trigger, .mark[href="#unread"])', function(event) {
			event.preventDefault();
			sp.loadPage($(this).attr('href'));
		})
		.on('click', '.page-jump-form :button', function() {
			var $input = $(this).siblings('input.inputbox');
			sp.pageJump($input);
		})
		.on('keypress', '.page-jump-form input.inputbox', function(event) {
			if (event.which === 13 || event.keyCode === 13) {
				event.preventDefault();
				sp.pageJump($(this));
			}
		})
		.on('click', '.dropdown-trigger', function() {
			var $dropdownContainer = $(this).parent();
			// Wait a little bit to make sure the dropdown has activated
			setTimeout(function() {
				if ($dropdownContainer.hasClass('dropdown-visible')) {
					$dropdownContainer.find('input.inputbox').focus();
				}
			}, 100);
		})
	$('body')
		.on('click', '#sp_more_page', function() {
			event.preventDefault();
			sp.loadPageMore($(this).attr('href'));
		})
};
/**
 * Handles dropdowns for the specified container.
 *
 * @param {jQuery} $container
 */
sp.handleDrops =function($container) {
	/**
	 * Dropdowns
	 */
	$container.find('.dropdown-container').each(function() {
		var $this = $(this),
			$trigger = $this.find('.dropdown-trigger:first'),
			$contents = $this.find('.dropdown'),
			options = {
				direction: 'auto',
				verticalDirection: 'auto'
			},
			data;

		if (!$trigger.length) {
			data = $this.attr('data-dropdown-trigger');
			$trigger = data ? $this.children(data) : $this.children('a:first');
		}

		if (!$contents.length) {
			data = $this.attr('data-dropdown-contents');
			$contents = data ? $this.children(data) : $this.children('div:first');
		}

		if (!$trigger.length || !$contents.length) {
			return;
		}

		if ($this.hasClass('dropdown-up')) {
			options.verticalDirection = 'up';
		}
		if ($this.hasClass('dropdown-down')) {
			options.verticalDirection = 'down';
		}
		if ($this.hasClass('dropdown-left')) {
			options.direction = 'left';
		}
		if ($this.hasClass('dropdown-right')) {
			options.direction = 'right';
		}

		phpbb.registerDropdown($trigger, $contents, options);
	});
}
sp.pageJump = function($item) {
	var page = parseInt($item.val(), 10);

	if (page !== null && !isNaN(page) && page === Math.floor(page) && page > 0) {
		var perPage = $item.attr('data-per-page'),
			baseUrl = $item.attr('data-base-url'),
			startName = $item.attr('data-start-name');

		if (baseUrl.indexOf('?') === -1) {
			sp.loadPage(baseUrl + '?' + startName + '=' + ((page - 1) * perPage));
		} else {
			sp.loadPage(baseUrl.replace(/&amp;/g, '&') + '&' + startName + '=' + ((page - 1) * perPage));
		}
	}
};
sp.dataObject = [];
sp.resultError = function(){};
sp.resultSuccess = function(){};
sp.requestMethod = 'GET';

sp.loadPage = function(url, requestData) {
	sp.ajax_url = url;
	if (requestData) {
		$.extend(sp.dataObject, requestData);
	}

	var $loadingIndicator = phpbb.loadingIndicator();

	var request = $.ajax({
		url: url,
		data: sp.dataObject,
		method: sp.requestMethod,
		error: sp.resultError,
		success: sp.resultSuccess,
		cache: false
	});
	request.always(function() {
		if ($loadingIndicator && $loadingIndicator.is(':visible')) {
			$loadingIndicator.fadeOut(phpbb.alertTime);
		}
	});
};
sp.loadPageMore = function(url, requestData) {
	sp.ajax_url = url;
	if (requestData) {
		$.extend(sp.dataObject, requestData);
	}

	$.ajax({
		url: url,
		data: sp.dataObject,
		method: sp.requestMethod,
		error: sp.resultError,
		success: sp.resultSuccessMore,
		cache: false
	});
};
sp.softScroll = function(target, container) {
	if (target.length) {
		container = container || 'html,body';
		$(container).animate({
			scrollTop: target.offset().top
		}, 10);
	}
};
sp.park = function(){
	$('body').on('keyup', '.park_filter', function () {
		var filter = $(this).val().toString().toUpperCase(),
			div = $(this).closest('div'),
			obj, txtValue;
		$('.park', div).each(function(index, el){
			obj = $(el);
			txtValue = obj.data('prop').toString();
			if (txtValue.toUpperCase().indexOf(filter) > -1) {
				obj.show();
			} else {
				obj.hide();
			}
		})
	})
	$('#park_list')
		.on('click', ".image_add", function(e){
			e.preventDefault();
			var $this = $(this),
				box = $this.closest('.park'),
				form = $this.closest('form'),
				id = box.data('id');

			$this.closest('form').ajaxSubmit({
				dataType: 'json',
				clearForm: true,
				complete: function (c, d) {
					if (c.responseJSON.error)
						$('.sp_error', box).html(c.responseJSON.error).show();
					if (c.responseJSON.img){
						for(var i in c.responseJSON.img){
							$(".park_img", box).append('<div class="lot_image" data-imgid="' + c.responseJSON.img[i].imgid + '"><img src="' + c.responseJSON.img[i].src + '" /><br><span class="image_del btn btn-sm btn-danger" title="{L_SP_DEL}"><i class="fa fa-trash-o" aria-hidden="true"></i></span></div>');
						}
					}
				}
			});
		})
		.on('click', ".image_del", function(e){
			e.preventDefault();
			var $this = $(this),
				box = $this.closest('.park'),
				id = box.data('id'),
				item = $this.closest('.lot_image'),
				pic_id = item.data('imgid');
			$.ajax({
				url: $(".park_img", box).data('url'),
				type: 'POST',
				data: {
					park_id: id,
					pic_id: pic_id
				},
				dataType: 'json',
				complete: function(result, errors) {
					item.remove();
				}
			});
			return false;
		})
}
sp.pay_s = function(){
	$(".datebox").pickmeup({
		position		: 'right',
		hide_on_select	: true,
		locale			: lang_ru,
		max				: 'D'
	});
	$('.paycheck').change(function(){
		var total = 0;
		$(".paycheck.pay:checked").each(function(){
			total += parseFloat($(this).val());
		});
		var overpayment;
		$(".paycheck.overpayment:checked").each(function(){
			overpayment = $(this);
			var v = parseFloat(overpayment.val());
			if (total < -v)
				overpayment.prop("checked", false);
			else
				total += v;
		});
		$('.total_pay_sel').html(total.toFixed(2));
		$('.itotal_pay_sel').val(total.toFixed(2));
	})

	phpbb.addAjaxCallback('klubsp.payment', function(response) {
		var panel = $(this).closest('.panel');
		panel.find(".payment_block").html(response.TEXT);
		$(".datebox", panel).pickmeup({
			position		: 'right',
			hide_on_select	: true,
			locale			: lang_ru,
			max				: 'D'
		});
		update_ajax(panel);
	});
};
sp.profile = function(){
	var AJAXRegistrationCheckPhone = $('#ajaxregistrationcheck-phone'),
		AJAXRegistrationCheckSMS = $('#ajaxregistrationcheck-sms'),

		phoneField = $('#sp_phone'),
		sendSMSBtn = $('#send_sms'),
		smsField = $('#sms_code');
	AJAXRegistrationCheckPhone.insertAfter(phoneField);
	phoneField.on('change', function() {
		var $this = $(this),
			value = $this.val();
		setLoading(AJAXRegistrationCheckLoading, AJAXRegistrationCheckPhone, $(this));
		$.ajax({
			url: AJAXRegistrationCheckPhoneCheckLink,
			type: 'POST',
			data: {'search': value},
			success: function(result) {
				if (result[0] === 'OK') {
					// The E-Mail address is allowed
					setValid(result[1], AJAXRegistrationCheckPhone, phoneField);
				} else if (result[0] === 'INVALID QUERY') {
					// The query was invalid
					setLoading(result[1], AJAXRegistrationCheckPhone, phoneField);
				} else {
					// The E-Mail address is not allowed for any reason
					setInvalid(result[1], AJAXRegistrationCheckPhone, phoneField);
				}
				$this.val(result[2]);
			}
		});
	});
	phoneField.trigger('change');
	var SMSBtn_interval = 10, SMSBtn_timer;
	var smsitter_x = function(){
		SMSBtn_interval--;
		sendSMSBtn.val(AJAXRegistrationCheckSMS2 + '(' + SMSBtn_interval + ')');
		if(SMSBtn_interval == 0){
			clearInterval(SMSBtn_timer);
			sendSMSBtn.val(AJAXRegistrationCheckSMS2).attr("disabled" , false);
		}

	};
	sendSMSBtn.on('click', function(){
		sendSMSBtn.attr("disabled" , true);
		SMSBtn_interval = 10;
		var value = phoneField.val(),
			sms_id = $('input[name="sms_id"]').val();
		$.ajax({
			url: AJAXRegistrationCheckSMSLink,
			type: 'POST',
			data: {'phone': value, 'sms_id': sms_id},
			success: function(result) {
				if (result[0] === 'OK') {
					setValid(result[1], AJAXRegistrationCheckSMS, smsField);
				} else if (result[0] === 'INVALID QUERY') {
					// The query was invalid
					setLoading(result[1], AJAXRegistrationCheckSMS, smsField);
				} else {
					// The E-Mail address is not allowed for any reason
					setInvalid(result[1], AJAXRegistrationCheckSMS, smsField);
				}
			}
		});
		SMSBtn_timer = setInterval(smsitter_x, 1000);
		return false;
	});
};
sp.purchase = function(){
	$(".status_data").pickmeup({
		position		: 'right',
		hide_on_select	: true,
		locale			: lang_ru,
		min				: 'D'
	});
	$('.sp-panel').on('change', '.upd', function(){$(this).closest('form').submit()});
	phpbb.addAjaxCallback('klubsp.cataloghide', function() {
		$(this).closest('span').toggleClass('act');
	});
	phpbb.addAjaxCallback('klubsp.reloadpurch', function(response) {
		var panel = $(this).closest('.sp-panel'),
			panel_id = panel.attr('id'),
			$obj = $(response).find("#"+panel_id);
		panel.html('').html($obj.html());
		$(".status_data", panel).pickmeup({
			position		: 'right',
			hide_on_select	: true,
			locale			: lang_ru,
			min				: 'D'
		});
		update_ajax(panel);
	});
	phpbb.addAjaxCallback('klubsp.del_catalog', function(response) {
		$(this).closest('.catalog_list_row').remove();
	});
};
sp.range = function(el){
	var parent = document.querySelector(el);
	if(!parent) return;

	var rangeS = parent.querySelectorAll("input[type=range]"),
		numberS = parent.querySelectorAll("input[type=number]");

	rangeS.forEach(function(el) {
		el.oninput = function() {
			var slide1 = parseFloat(rangeS[0].value),
				slide2 = parseFloat(rangeS[1].value);

			if (slide1 > slide2) {
				[slide1, slide2] = [slide2, slide1];
			}

			numberS[0].value = slide1;
			numberS[1].value = slide2;
		}
	});

	numberS.forEach(function(el) {
		el.oninput = function() {
			var number1 = parseFloat(numberS[0].value),
				number2 = parseFloat(numberS[1].value);

			if (number1 > number2) {
				[numberS[0].value, numberS[1].value] = [number2, number1];
			}

			rangeS[0].value = number1;
			rangeS[1].value = number2;
		}
	});
}
sp.registr = function(){
	var AJAXRegistrationCheckUsername = $('#ajaxregistrationcheck-username'),
		AJAXRegistrationCheckEMail = $('#ajaxregistrationcheck-email'),
		AJAXRegistrationCheckPassword = $('#ajaxregistrationcheck-password'),
		AJAXRegistrationCheckConfirmPassword = $('#ajaxregistrationcheck-confirm-password'),
		AJAXRegistrationCheckPhone = $('#ajaxregistrationcheck-phone'),
		AJAXRegistrationCheckSMS = $('#ajaxregistrationcheck-sms'),

		AJAXRegistrationCheckEMailRule = new RegExp(AJAXRegistrationCheckEMailRule, 'i'),
		AJAXRegistrationCheckUsernameRule = new RegExp(AJAXRegistrationCheckUsernameRule, 'i'),

		passwordField = $('#new_password'),
		passwordConfirmationField = $('#password_confirm'),
		usernameField = $('#username'),
		eMailField = $('#email'),
		phoneField = $('#new_phone'),
		sendSMSBtn = $('#send_sms'),
		smsField = $('#sms_code');
	AJAXRegistrationCheckConfirmPassword.insertAfter(passwordConfirmationField);
	passwordConfirmationField.on('keyup', function() {
		if ($(this).val() === passwordField.val()) {
			// The given passwords match
			setValid(AJAXRegistrationCheckConfirmPasswordValid, AJAXRegistrationCheckConfirmPassword, $(this));
		} else {
			// The given passwords don't match
			setInvalid(AJAXRegistrationCheckConfirmPasswordInvalid, AJAXRegistrationCheckConfirmPassword, $(this));
		}
	});

	if (passwordConfirmationField.val())
		passwordConfirmationField.trigger('keyup');

	AJAXRegistrationCheckPassword.insertAfter(passwordField);
	passwordField.on('keyup', function() {
		passwordConfirmationField.trigger('keyup');
		var value = $(this).val();
		var containsLowerCase = value.match(/[a-z]/g);
		var containsUpperCase = value.match(/[A-Z]/g);
		var containsNumber = value.match(/[0-9]/g);
		var containsSymbol = value.match(/[^a-zA-Z0-9]/g);
		var valid = false;
		if (value.length < AJAXRegistrationCheckPasswordMin || value.length > AJAXRegistrationCheckPasswordMax) {
			// The password is too short or too long
			setInvalid(AJAXRegistrationCheckPasswordInvalid, AJAXRegistrationCheckPassword, $(this));
		} else {
			if (AJAXRegistrationCheckPasswordRule <= 0) {
				// The password is allowed because it has no matching rules
				valid = true;
			} else if (containsLowerCase && containsUpperCase) {
				if (AJAXRegistrationCheckPasswordRule <= 10) {
					// The password contains all needed characters
					valid = true;
				} else if (containsNumber) {
					if (AJAXRegistrationCheckPasswordRule <= 100) {
						// The password contains all needed characters
						valid = true;
					} else if (containsSymbol) {
						// The password contains all needed characters
						valid = true;
					} else {
						// The password is incorrect because it has to contain at least also a symbol
						setInvalid(AJAXRegistrationCheckPasswordInvalid, AJAXRegistrationCheckPassword, $(this));
					}
				} else {
					// The password is incorrect because it has to contain at least also a number
					setInvalid(AJAXRegistrationCheckPasswordInvalid, AJAXRegistrationCheckPassword, $(this));
				}
			} else {
				// The password is incorrect because it has to contain at least upper and lower case characters
				setInvalid(AJAXRegistrationCheckPasswordInvalid, AJAXRegistrationCheckPassword, $(this));
			}
		}
		if (valid) {
			var percentage = 0;
			// Check password strength
			if (containsLowerCase) {
				// Password should contain at least 5 lower case characters
				percentage += (containsLowerCase.length > 5 ? 5 : containsLowerCase.length) * 5;
			}
			if (containsUpperCase) {
				// Password should contain at least 3 upper case characters
				percentage += (containsUpperCase.length > 3 ? 3 : containsUpperCase.length) * 7;
			}
			if (containsNumber) {
				// Password should contain at least 2 numbers
				percentage += (containsNumber.length > 2 ? 2 : containsNumber.length) * 10;
			}
			if (containsSymbol) {
				// Password should contain at least 2 symbols
				percentage += (containsSymbol.length > 2 ? 2 : containsSymbol.length) * 14;
			}
			if ((usernameField.val() === '' || value.indexOf(usernameField.val()) < 0) && (eMailField.val() === '' || value.indexOf(eMailField.val()) < 0)) {
				// Password should not contain username or E-Mail address
				percentage += 6;
			}
			if (AJAXRegistrationCheckPassword.hasClass('invalid')) {
				AJAXRegistrationCheckPassword.removeClass('invalid').addClass('password-strength');
				var securityHTML = '<span>' + AJAXRegistrationCheckPasswordStrength + '</span>';
				securityHTML += '<div class="progressbar"><div id="ajaxregistrationcheck-security">&nbsp;</div></div>';
				securityHTML += '<span id="ajaxregistrationcheck-strength"></span>';
				AJAXRegistrationCheckPassword.html(securityHTML);
			}
			// Set password status
			$(this).get(0).setCustomValidity('');
			var securityPB = $('#ajaxregistrationcheck-security');
			var strengthText = $('#ajaxregistrationcheck-strength');
			securityPB.stop().animate({width: percentage + '%', overflow: 'overflow'}, 800);
			if (percentage >= 95) {
				strengthText.html(AJAXRegistrationCheckPasswordVeryStrong);
				securityPB.removeClass().addClass('very-strong');
			} else if (percentage >= 85) {
				strengthText.html(AJAXRegistrationCheckPasswordStrong);
				securityPB.removeClass().addClass('strong');
			} else if (percentage >= 60) {
				strengthText.html(AJAXRegistrationCheckPasswordNormal);
				securityPB.removeClass().addClass('normal');
			} else if (percentage >= 45) {
				strengthText.html(AJAXRegistrationCheckPasswordWeak);
				securityPB.removeClass().addClass('weak');
			} else {
				strengthText.html(AJAXRegistrationCheckPasswordVeryWeak);
				securityPB.removeClass().addClass('very-weak');
			}
		} else {
			AJAXRegistrationCheckPassword.removeClass('password-strength');
		}
	});
	if (passwordField.val())
		passwordField.trigger('keyup');

	AJAXRegistrationCheckUsername.insertAfter(usernameField);
	usernameField.on('keyup', function() {
		passwordField.trigger('keyup');
		var value = $(this).val();
		if (value.length < AJAXRegistrationCheckUsernameMin || value.length > AJAXRegistrationCheckUsernameMax || value.match(AJAXRegistrationCheckUsernameRule) === null) {
			// Username doesn't match the naming guidelines
			setInvalid(AJAXRegistrationCheckUsernameInvalidBoundaries, AJAXRegistrationCheckUsername, $(this));
		} else {
			// Check username online
			setLoading(AJAXRegistrationCheckLoading, AJAXRegistrationCheckUsername, $(this));
			$.ajax({
				url: AJAXRegistrationCheckUsernameCheckLink,
				type: 'POST',
				data: {'search': value},
				success: function(result) {
					if (result[0] === 'OK') {
						// Username is allowed
						setValid(result[1], AJAXRegistrationCheckUsername, usernameField);
					} else if (result[0] === 'INVALID QUERY') {
						// The query was invalid
						setLoading(result[1], AJAXRegistrationCheckUsername, usernameField);
					} else {
						// Username not allowed for any reason
						setInvalid(result[1], AJAXRegistrationCheckUsername, usernameField);
					}
				}
			});
		}
	});
	if (usernameField.val())
		usernameField.trigger('keyup');

	AJAXRegistrationCheckEMail.insertAfter(eMailField);
	eMailField.on('keyup', function() {
		passwordField.trigger('keyup');
		var value = $(this).val();
		if (value.match(AJAXRegistrationCheckEMailRule) === null) {
			// The input is not a valid E-Mail address
			setInvalid(AJAXRegistrationCheckEMailInvalid, AJAXRegistrationCheckEMail, $(this));
		} else {
			setLoading(AJAXRegistrationCheckLoading, AJAXRegistrationCheckEMail, $(this));
			$.ajax({
				url: AJAXRegistrationCheckEMailCheckLink,
				type: 'POST',
				data: {'search': value},
				success: function(result) {
					if (result[0] === 'OK') {
						// The E-Mail address is allowed
						setValid(result[1], AJAXRegistrationCheckEMail, eMailField);
					} else if (result[0] === 'INVALID QUERY') {
						// The query was invalid
						setLoading(result[1], AJAXRegistrationCheckEMail, eMailField);
					} else {
						// The E-Mail address is not allowed for any reason
						setInvalid(result[1], AJAXRegistrationCheckEMail, eMailField);
					}
				}
			});
		}
	});
	if (eMailField.val())
		eMailField.trigger('keyup');

	AJAXRegistrationCheckPhone.insertAfter(phoneField);
	phoneField.on('change', function() {
		var $this = $(this),
			value = $this.val();
		setLoading(AJAXRegistrationCheckLoading, AJAXRegistrationCheckPhone, $(this));
		$.ajax({
			url: AJAXRegistrationCheckPhoneCheckLink,
			type: 'POST',
			data: {'search': value},
			success: function(result) {
				if (result[0] === 'OK') {
					// The E-Mail address is allowed
					setValid(result[1], AJAXRegistrationCheckPhone, phoneField);
				} else if (result[0] === 'INVALID QUERY') {
					// The query was invalid
					setLoading(result[1], AJAXRegistrationCheckPhone, phoneField);
				} else {
					// The E-Mail address is not allowed for any reason
					setInvalid(result[1], AJAXRegistrationCheckPhone, phoneField);
				}
				$this.val(result[2]);
			}
		});
	});
	if (phoneField.val())
		phoneField.trigger('change');

	var SMSBtn_interval = 10, SMSBtn_timer;
	var smsitter_x = function(){
		SMSBtn_interval--;
		sendSMSBtn.val(AJAXRegistrationCheckSMS2 + '(' + SMSBtn_interval + ')');
		if(SMSBtn_interval == 0){
			clearInterval(SMSBtn_timer);
			sendSMSBtn.val(AJAXRegistrationCheckSMS2).attr("disabled" , false);
		}

	};
	sendSMSBtn.on('click', function(){
		sendSMSBtn.attr("disabled" , true);
		SMSBtn_interval = 10;
		var value = phoneField.val(),
			sms_id = $('input[name="sms_id"]').val();
		$.ajax({
			url: AJAXRegistrationCheckSMSLink,
			type: 'POST',
			data: {'phone': value, 'sms_id': sms_id},
			success: function(result) {
				if (result[0] === 'OK') {
					setValid(result[1], AJAXRegistrationCheckSMS, null);
				} else if (result[0] === 'INVALID QUERY') {
					// The query was invalid
					setLoading(result[1], AJAXRegistrationCheckSMS, null);
				} else {
					// The E-Mail address is not allowed for any reason
					setInvalid(result[1], AJAXRegistrationCheckSMS, null);
				}
			}
		});
		SMSBtn_timer = setInterval(smsitter_x, 1000);
	});
};
var count_selected, set_ajax;
sp.report = function(){
	var img_arr = [];
	$('#vikup_sel').change(function(){
		window.location = $( "#vikup_sel option:selected" ).data('url');
	});
	function set_img($this, url){
		$this.attr('src', url).removeClass('load_img');
		if($this.data('img'))
			$this.addClass('magnify');
	}
	function load_img($this){
		var url = $this.data('src'),
			img = new Image();
		img_arr.push(url);
		img.onload = function(){
			set_img($this, url)
		};
		img.src = url;
	}
	$('#report_main')
		.on('change', '.order_select', function(){count_selected()})
		.on('click', '.load_img', function(){
			var $this = $(this);
			load_img($this)
		})
		.on('click', '.magnify', function(){
			magnify(this);
		})
		.on('change', '.formsend', function(){
			$(this).closest('form').trigger('submit');
		})
		;
	$('#loadimg').click(function(){
		$('.load_img').each(function(){
			var $this = $(this);
			load_img($this)
		})
	})

	$('#change_selected_orders_state').click(function(){
		var orders = get_sel_order(true);
		if (orders) set_ajax({task: "change_orders_state", state: getE("selected_orders_status_selector").value, orders: orders});
	});
	$('#selected_set_delivery').click(function(){
		var orders = get_sel_order(true), p = $("input:radio[name='delivery_p']:checked").val();
		if (orders)
			set_ajax({task: "set_delivery", value: getE("sel_delivery").value, f: p, orders: orders});
	});
	$('.new_event_send').click(function(){
		var $obj = $(this),
		$form = $obj.closest('form'),
		a = '';
		$(".user_orders").each(function(){
			if ($('.order_select:checked',this).length)
				a += '<input type="hidden" value="to" name="address_list[u][' + $(this).data('user') + ']">';
		});
		$(".new_event_hid", $form).html(a);
		$form.submit();
		return false;
	});
	$('.export_selected').click(function(){
		var $this = $(this), et = $this.data('et'), ft = $this.data('ft'), html = '';
		html += '<input type="hidden" value="export_selected" name="task">';
		html += '<input type="hidden" value="' + get_sel_order(true) + '" name="order_ids">';
		html += '<input type="hidden" value="' + et + '" name="etype">';
		html += '<input type="hidden" value="' + ft + '" name="ftype">';
		$("#action_hid").html(html);
		$("#action_form").submit();
	});
	$('.select_orders').click(function(){
		var a = parseInt($(this).data('f')), b = getE("selector").value;
		if (-1 == b){
			if (a){
				$('.order_select:not(:checked)').prop("checked", true);
			}else{
				$('.order_select:checked').prop("checked", false);
			}
		}else{
			$('.order_select').each(function(){
				if ($('.order_status', $(this).closest('.inner')).val() == b) $(this).prop("checked", a);
			});
		}
		count_selected();
	});
	$('.select_orders_c').click(function(){
		var a = parseInt($(this).data('f')), b = getE("selector2").value;
		if (-1 == b){
			if (a){
				$('.order_select:not(:checked)').prop("checked", true);
			}else{
				$('.order_select:checked').prop("checked", false);
			}
		}else{
			$('.c'+b).prop("checked", a);
		}
		count_selected();
	});
	$('.select_orders_ss').click(function(){
		var $this = $(this), s = $this.data('s'), f = parseInt($this.data('f'));
		$('.ss'+s).prop("checked", f);
		count_selected();
	});
	$('.select_orders_pr').click(function(){
		var $this = $(this), f = parseInt($this.data('f')), s = $('#selector_pr').val();
		$('.oci'+s).prop("checked", f);
		count_selected();
	});

	function get_sel_order(f){
		var a = [];
		$('.order_select:checked').each(function(){
			a.push($(this).val());
		});
		return ((f)?a.join(','):a);
	}
	phpbb.addAjaxCallback('klubsp.reloaduser', function(response) {
		if (spreload)
			location.reload();
		var $this = $(this).parent(),
			$obj = $(response).find(".userdata").parent();
		$this.html($obj.html());
		$('.load_img', this).each(function(){
			var $this_i = $(this),
				url = $this_i.data('src');
			if (img_arr.indexOf(url) != -1 ){
				set_img($this_i, url)
			}
		})
		count_selected();
		update_ajax($this);
	});
	if ($('#loadimg').is(':checked')){
		$('.load_img').each(function(){
			var $this = $(this);
			load_img($this)
		})
	}
	count_selected = function (){
		$('.orders_selected').html($('.order_select:checked').length);
	}
	set_ajax = function (data){
		var $sploadingIndicator = phpbb.loadingIndicator();
		$.ajax({
			type: "POST",
			data: data,
			success: function (d, l) {
				reload_report(d);
			},
			complete: function() {
				if ($sploadingIndicator && $sploadingIndicator.is(':visible')) {
					$sploadingIndicator.fadeOut(phpbb.alertTime);
				}
			}
		});
	}
	function reload_report(response)
	{
		var $this = $('#report_main'),
			$obj = $(response).find("#report_main");
		$this.html($obj.html());
		$('.load_img', $this).each(function(){
			var $this = $(this),
				url = $this.data('src');
			if (img_arr.indexOf(url) != -1 ){
				set_img($this, url)
			}
		})
		count_selected();
		update_ajax($this);
	}
	phpbb.addAjaxCallback('klubsp.reload_report', function(response) {
		reload_report(response);
	});
	phpbb.addAjaxCallback('klubsp.reloaduser_total', function(response) {
		var $obj = $(response).find(".userdata .order-total");
		$(".order-total", this).html($obj.html());
		count_selected();
	});
};
sp.reserv = function(){
	$('.ch_request_message')
		.on('change', function () {
			var $obj = $(this),
				id = $obj.data('id'),
				a = $('#a'+id);
				a.show();
			$.ajax({
				type : 'POST',
				data : {
					task: "ch_request_message",
					id: id,
					text: $obj.val()
				},
				dataType: 'json',
				success: function (b) {
					$obj.val(b.msg);
				},
				complete: function(){
					a.hide();
				}
			});
		});
	$('#reservlist')
		.on('click', ".seljs", function(){
			var $obj = $(this),
				form = $("#form-filter");
			$('input', form).val('');
			$('#'+$obj.data('id')).val($obj.data('val'));
			form.submit();
		});
	$("#new_reserv")
		.on('change', ".check_provider", function(){check_provider();})
		.on('click', ".provider_sel", function(){
			var $obj = $(this);
			$('#provider').val($obj.data('name'));
			$('#provider_url').val($obj.data('url'));
			check_provider();
		})
		.on('change', "#brand_label", function(){check_brand();})
	;
	function check_provider(){
		$('#check_provider_war').html('').hide();
		$('#check_provider_err').html('').hide();
		$.ajax({
			type: 'POST',
			data: {
				task: "check_provider_ajax",
				provider: $('#provider').val(),
				provider_url: $('#provider_url').val()
			},
			dataType: 'json',
			success: function (a, b) {
				if (a.msg){
					$('#check_provider_war').html(a.msg).show();
				}
				if (a.error){
					$('#check_provider_err').html(a.error).show();
				}
				$('#provider').val(a.provider_name);
				$('#provider_url').val(a.provider_url);
			}
		});
	}
	function check_brand(){
		$('#check_brand_war').html('').hide();
		$.ajax({
			type : 'POST',
			data : {
				task: "check_brand_ajax",
				brand_label: $('#brand_label').val()
			},
			dataType: 'json',
			success: function (a, b) {
				if (a.msg){
					$('#check_brand_war').html(a.msg).show();
				}
				$('#brand_label').val(a.brand);
			}
		});
	}
};
function getTimeRemaining(endtime) {
  let t = Date.parse(endtime) - Date.parse(new Date()),
      seconds = Math.floor((t / 1000) % 60),
      minutes = Math.floor((t / 1000 / 60) % 60),
      hours = Math.floor((t / (1000 * 60 * 60)) % 24),
      days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

function initializeClock(id) {
  var clock = document.getElementById(id),
      daysSpan = clock.querySelector('.days'),
      hoursSpan = clock.querySelector('.hours'),
      minutesSpan = clock.querySelector('.minutes'),
      secondsSpan = clock.querySelector('.seconds'),
      endtime = clock.dataset.time;

  function updateClock() {
    var t = getTimeRemaining(endtime);

    daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}
(function($) {  // Avoid conflicts with other libraries
	if ($(window).scrollTop() >= "230")
		$("#ToTop").fadeIn("slow");
	$(window).scroll(function() {
		if ($(window).scrollTop() <= "230") $("#ToTop").fadeOut("slow");
			else $("#ToTop").fadeIn("slow");
	});

	if ($(window).scrollTop() <= $(document).height()-"999")
		$("#ToBottom").fadeIn("slow");

	$(window).scroll(function() {
		if ($(window).scrollTop() >= $(document).height()-"999") $("#ToBottom").fadeOut("slow");
			else $("#ToBottom").fadeIn("slow");
	});

	$("#ToTop").click(function() { $("html,body").animate({scrollTop:0},"700"); });
	$("#ToBottom").click(function() { $("html,body").animate({scrollTop:$(document).height()},"700"); });
})($); // Avoid conflicts with other libraries

function update_ajax(obj){
	$('[data-ajax]', obj).each(function() {
		var $this = $(this),
			ajax = $this.data('ajax'),
			filter = $this.data('filter');
		if (ajax !== 'false') {
			var fn = (ajax !== 'true') ? ajax : null;
				filter = (filter !== undefined) ? phpbb.getFunctionByName(filter) : null;
			phpbb.ajaxify({
				selector: this,
				refresh: $this.attr('data-refresh') !== undefined,
				filter: filter,
				callback: fn
			});
		}
	});
}
function modal_sp(fajax){
	if (fajax){
		update_ajax($('#modal_box'));
		$("#modal_box .datebox").pickmeup({
			position		: 'right',
			hide_on_select	: true,
			locale			: lang_ru,
			max				: 'D'
		});
	}
}

phpbb.addAjaxCallback('klubsp.toggle', function(response) {
	$(this).attr('href', response.URL).html(response.DATA);
});
phpbb.addAjaxCallback('klubsp.comment', function(response) {
	var panel = $(this).closest('.panel');
	panel.html($(response).html());
	update_ajax(panel);
});
phpbb.addAjaxCallback('klubsp.lot_block', function(response) {
	$(response).appendTo('body').spmodal().on($.spmodal.BEFORE_CLOSE, function(event, modal) {
		$('#lot_body').remove();
	});
	sp.lot(true);
});
phpbb.addAjaxCallback('klubsp.return', function(response) {
	$(this).closest('div').html(response.data);
});
phpbb.addAjaxCallback('klubsp.cart_msg', function(response){
	if (response.msg != undefined)
	{
		var html = '<div id="cart_msg">' + response.msg + '</div>';
		$(html).appendTo('body');
		setTimeout(function(){
			var cart_msg = $('#cart_msg');
			cart_msg
				.css({
					'position': 'absolute',
					'left':cart_msg.offset()['left'],
					'top':cart_msg.offset()['top']
				})
				.animate({opacity: 0.05,
					left: $("#cart_link").offset()['left'],
					top: $("#cart_link").offset()['top'],
					position: 'absolute',
					width: 20}, 1500, "linear", function(){$(this).remove();}
				);
		}, 1000);
	}
});
phpbb.addAjaxCallback('klubsp.modal', spmodal_set);
phpbb.addAjaxCallback('klubsp.modal_exhange', function(response){
	spmodal_set(response);
	if (sp['exchange'])
	{
		sp.exchange();
	}
});
phpbb.addAjaxCallback('klubsp.feedback_comm', function(response){
	var $this = $(this),
		id = $this.data('id'),
		block = $('#feedback_comm' + id),
		html = $(response).find('#feedback_comm' + id).html();
	if (!html){
		html = ' ';
	}
	$('input[name=comm]', $this).val('');
	block.html(html);
	update_ajax(block);
});
phpbb.addAjaxCallback('klubsp.feedback_del', function(response){
	var id = $(this).data('id');
	$('#feedback' + id).remove();
});
phpbb.addAjaxCallback('klubsp.import_log', function(response){
	$('#import_log').html(response).show();
});

(function($) {
	apply_js('body');
	$('.sp_timer').each((e) => {initializeClock(e.id)});
	sp.page_ajax = false;
	if (typeof page_ajax !== 'undefined')
	{
		sp.page_ajax = page_ajax;
	}
	if (typeof mode !== 'undefined' && sp[mode])
	{
		sp[mode]();
	}
	$('body')
		.on('click', '.ajaxmodalof', function(event) {
			event.preventDefault();
			$.ajax({
				url : this.href,
				type : 'POST',
				dataType: 'html',
				success : function(result) {
					$(result).appendTo('body').spmodal();
					update_ajax('#office_item');
				}
			});
		})
		.on('click', '.copyclipboard', function(event) {
			event.preventDefault();
			var data = $(this).data('url');
			if (navigator.clipboard) {
				navigator.clipboard.writeText(data).catch(err => {console.log('Something went wrong', err);});
			} else {
				var copytext = document.createElement('input');
				copytext.value = data;
				document.body.appendChild(copytext);
				copytext.select();
				document.execCommand('copy');
				document.body.removeChild(copytext);
			}
		})
		.on('click', '#feedback_order_add', function(event) {
			event.preventDefault();
			var $this = $(this),
				form = $this.closest('form');
			$('.sp_success', form).hide();
			form.ajaxSubmit({
				dataType: 'json',
				clearForm: true,
				complete: function (c, d) {
					if (c.responseJSON.msg){
						$('.sp_success', form).html(c.responseJSON.msg).show();
					}
				}
			});
			return false;
		})
		.on('click', '.password-view', function(){
			let $this = $(this),
				block = $this.parent(),
				input = $('input'. block);
			if (input.attr('type') == 'password'){
				$this.addClass('viewpass');
				input.attr('type', 'text');
			} else {
				$this.removeClass('viewpass');
				input.attr('type', 'password');
			}
			return false;
		})
})($); // Avoid conflicts with other libraries